import {
  LendingDisbursementPaymentOptionsInput,
  LendingDisbursementPaymentOptionsSuccess,
  LendingPaymentTypeInput,
  Query,
} from '@varo/graphql-schema-types';
import { isLendingDisbursementPaymentOptionsSuccess } from 'features/advance/helpers/Advance.helpers';
import fetchLendingDisbursementPaymentOptions from 'services/graphql/queries/advance/fetchLendingDisbursementOptions';
import useCancellableQuery from 'shared/hooks/useCancellableQuery/useCancellableQuery';
import { CombinedError, useQuery } from 'urql';

interface LendingDisbursementPaymentOptionsResult {
  options: LendingDisbursementPaymentOptionsSuccess | undefined;
  error?: CombinedError;
  loading: boolean;
  refetch: () => Promise<void>;
}

const useAdvancePaymentOptions = (
  paymentType: LendingPaymentTypeInput,
): LendingDisbursementPaymentOptionsResult => {
  const [fetchPaymentOptions] = useCancellableQuery<Query>(
    fetchLendingDisbursementPaymentOptions,
  );
  const input: LendingDisbursementPaymentOptionsInput = {
    includeAccountBalance: true,
    paymentType: paymentType,
  };
  const [response] = useQuery<Query>({
    query: fetchLendingDisbursementPaymentOptions,
    variables: { input },
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = response;

  const refetch = async () => {
    await fetchPaymentOptions(
      {
        input: {
          includeAccountBalance: true,
          paymentType,
        },
      },
      { requestPolicy: 'network-only' },
    );
  };

  const lendingDisbursementPaymentOptions =
    isLendingDisbursementPaymentOptionsSuccess(
      data?.lendingDisbursementPaymentOptions,
    )
      ? data.lendingDisbursementPaymentOptions
      : undefined;

  return {
    options: lendingDisbursementPaymentOptions,
    loading: fetching,
    error,
    refetch,
  };
};

export default useAdvancePaymentOptions;
